import type { JobCategory } from '../types';

export const jobCategories: JobCategory[] = [
  {
    id: 'rd',
    name: '研发类',
    icon: 'Code2',
    color: '#3B82F6',
    description: '技术研发与工程实现',
    subPositions: [
      { id: 'java', name: 'Java开发工程师', description: '企业级后端开发', hot: true },
      { id: 'frontend', name: '前端开发工程师', description: 'Web界面开发', hot: true },
      { id: 'backend', name: '后端开发工程师', description: '服务端开发', hot: true },
      { id: 'fullstack', name: '全栈开发工程师', description: '前后端全栈开发', hot: true },
      { id: 'mobile', name: '移动端开发工程师', description: 'iOS/Android开发' },
      { id: 'algorithm', name: '算法工程师', description: '机器学习与算法', hot: true },
      { id: 'agent', name: 'Agent开发工程师', description: 'AI智能体开发', hot: true },
      { id: 'bigdata', name: '大数据开发工程师', description: '大数据平台开发' },
      { id: 'test', name: '测试工程师', description: '软件质量保证' },
      { id: 'devops', name: 'DevOps工程师', description: '运维与自动化' },
      { id: 'architect', name: '架构师', description: '系统架构设计', hot: true },
    ],
  },
  {
    id: 'design',
    name: '设计类',
    icon: 'Palette',
    color: '#8B5CF6',
    description: '创意设计与用户体验',
    subPositions: [
      { id: 'ui', name: 'UI设计师', description: '用户界面设计', hot: true },
      { id: 'ux', name: 'UX设计师', description: '用户体验设计', hot: true },
      { id: 'visual', name: '视觉设计师', description: '视觉创意设计' },
      { id: 'interaction', name: '交互设计师', description: '交互流程设计' },
      { id: 'brand', name: '品牌设计师', description: '品牌形象设计' },
      { id: 'illustration', name: '插画师', description: '插画与图形设计' },
      { id: '3d', name: '3D设计师', description: '三维设计与建模' },
      { id: 'motion', name: '动效设计师', description: '动画与动效设计' },
      { id: 'game-art', name: '游戏美术设计师', description: '游戏视觉设计' },
      { id: 'design-lead', name: '设计总监', description: '设计团队管理', hot: true },
    ],
  },
  {
    id: 'management',
    name: '管理类',
    icon: 'Users',
    color: '#D4AF37',
    description: '团队管理与业务统筹',
    subPositions: [
      { id: 'pm', name: '产品经理', description: '产品规划与管理', hot: true },
      { id: 'project-manager', name: '项目经理', description: '项目交付管理' },
      { id: 'tech-manager', name: '技术经理', description: '技术团队管理', hot: true },
      { id: 'ops-manager', name: '运营经理', description: '业务运营管理' },
      { id: 'hr-manager', name: '人力资源经理', description: 'HR团队管理' },
      { id: 'admin-manager', name: '行政经理', description: '行政管理' },
      { id: 'director', name: '部门总监', description: '部门战略管理', hot: true },
      { id: 'ceo', name: '总经理/CEO', description: '公司整体运营', hot: true },
      { id: 'team-lead', name: '团队主管', description: '小团队管理' },
      { id: 'scrum-master', name: '敏捷教练', description: '敏捷转型指导' },
    ],
  },
  {
    id: 'finance',
    name: '财务类',
    icon: 'Calculator',
    color: '#10B981',
    description: '财务管理与资金运营',
    subPositions: [
      { id: 'accountant', name: '财务会计', description: '日常财务核算' },
      { id: 'cost-accountant', name: '成本会计', description: '成本核算分析' },
      { id: 'tax-accountant', name: '税务会计', description: '税务申报筹划' },
      { id: 'auditor', name: '审计师', description: '内部外部审计' },
      { id: 'financial-analyst', name: '财务分析师', description: '财务数据分析', hot: true },
      { id: 'budget-analyst', name: '预算分析师', description: '预算编制管理' },
      { id: 'treasury', name: '资金管理专员', description: '资金调度管理' },
      { id: 'cfo', name: '财务经理/CFO', description: '财务战略管理', hot: true },
      { id: 'investment-analyst', name: '投资分析师', description: '投资分析决策' },
      { id: 'risk-control', name: '风控专员', description: '风险控制管理' },
    ],
  },
  {
    id: 'marketing',
    name: '市场与销售类',
    icon: 'TrendingUp',
    color: '#F97316',
    description: '市场拓展与商业变现',
    subPositions: [
      { id: 'marketing-specialist', name: '市场营销专员', description: '市场推广执行' },
      { id: 'brand-manager', name: '品牌经理', description: '品牌建设管理', hot: true },
      { id: 'market-analyst', name: '市场分析师', description: '市场调研分析' },
      { id: 'sales-rep', name: '销售代表', description: '客户开发与维护' },
      { id: 'key-account', name: '大客户销售', description: 'KA客户管理', hot: true },
      { id: 'channel-manager', name: '渠道经理', description: '渠道拓展管理' },
      { id: 'bd', name: '商务拓展', description: '商务合作拓展', hot: true },
      { id: 'crm', name: '客户关系管理', description: 'CRM系统运营' },
      { id: 'promotion', name: '市场推广专员', description: '推广活动策划' },
      { id: 'sales-director', name: '销售总监', description: '销售团队管理', hot: true },
    ],
  },
  {
    id: 'operations',
    name: '运营类',
    icon: 'Settings',
    color: '#EC4899',
    description: '业务运营与用户增长',
    subPositions: [
      { id: 'content-ops', name: '内容运营', description: '内容策划与运营', hot: true },
      { id: 'user-ops', name: '用户运营', description: '用户生命周期管理', hot: true },
      { id: 'activity-ops', name: '活动运营', description: '活动策划执行' },
      { id: 'data-ops', name: '数据运营', description: '数据驱动运营' },
      { id: 'community-ops', name: '社群运营', description: '社群生态建设' },
      { id: 'newmedia-ops', name: '新媒体运营', description: '自媒体运营', hot: true },
      { id: 'ecommerce-ops', name: '电商运营', description: '电商平台运营', hot: true },
      { id: 'product-ops', name: '产品运营', description: '产品功能运营' },
      { id: 'growth', name: '增长黑客', description: '用户增长策略', hot: true },
      { id: 'ops-director', name: '运营总监', description: '运营团队管理', hot: true },
    ],
  },
  {
    id: 'hr',
    name: '人力资源类',
    icon: 'UserPlus',
    color: '#06B6D4',
    description: '人才招聘与组织发展',
    subPositions: [
      { id: 'recruiter', name: '招聘专员', description: '人才招聘实施', hot: true },
      { id: 'training', name: '培训专员', description: '员工培训发展' },
      { id: 'compensation', name: '薪酬福利专员', description: '薪酬体系管理' },
      { id: 'performance', name: '绩效考核专员', description: '绩效管理实施' },
      { id: 'er', name: '员工关系专员', description: '员工关系维护' },
      { id: 'hrbp', name: 'HRBP', description: '业务伙伴支持', hot: true },
      { id: 'headhunter', name: '猎头顾问', description: '高端人才猎寻' },
      { id: 'od', name: '组织发展专员', description: '组织能力建设' },
      { id: 'hr-director', name: '人力资源总监', description: 'HR战略管理', hot: true },
      { id: 'talent-development', name: '人才发展专员', description: '人才梯队建设' },
    ],
  },
  {
    id: 'admin',
    name: '行政与支持类',
    icon: 'Building2',
    color: '#64748B',
    description: '行政后勤与综合支持',
    subPositions: [
      { id: 'admin-specialist', name: '行政专员', description: '日常行政事务' },
      { id: 'receptionist', name: '前台接待', description: '前台接待服务' },
      { id: 'secretary', name: '文秘/助理', description: '文书与助理工作' },
      { id: 'logistics', name: '后勤管理', description: '后勤保障管理' },
      { id: 'purchasing', name: '采购专员', description: '物资采购管理' },
      { id: 'archives', name: '档案管理', description: '档案资料管理' },
      { id: 'conference', name: '会务管理', description: '会议活动组织' },
      { id: 'facility', name: '设施管理', description: '办公设施维护' },
      { id: 'fleet', name: '车辆管理', description: '公司车辆管理' },
      { id: 'security', name: '安保管理', description: '安全保卫工作' },
    ],
  },
  {
    id: 'legal',
    name: '法务与合规类',
    icon: 'Scale',
    color: '#6366F1',
    description: '法律事务与合规管理',
    subPositions: [
      { id: 'legal-specialist', name: '法务专员', description: '日常法务工作' },
      { id: 'contract', name: '合同管理专员', description: '合同审核管理' },
      { id: 'ip', name: '知识产权专员', description: '知识产权管理', hot: true },
      { id: 'compliance', name: '合规专员', description: '合规体系建设' },
      { id: 'lawyer', name: '律师/法律顾问', description: '法律咨询顾问' },
      { id: 'litigation', name: '诉讼专员', description: '诉讼案件处理' },
      { id: 'legal-director', name: '法务经理/总监', description: '法务团队管理', hot: true },
      { id: 'compliance-director', name: '合规经理', description: '合规团队管理' },
      { id: 'data-protection', name: '数据保护专员', description: '数据合规管理', hot: true },
      { id: 'anti-fraud', name: '反舞弊专员', description: '内部调查审计' },
    ],
  },
  {
    id: 'service',
    name: '客户服务类',
    icon: 'Headphones',
    color: '#14B8A6',
    description: '客户支持与满意度管理',
    subPositions: [
      { id: 'customer-service', name: '客服专员', description: '客户咨询服务' },
      { id: 'tech-support', name: '技术支持', description: '技术问题解决' },
      { id: 'csm', name: '客户成功经理', description: '客户成功管理', hot: true },
      { id: 'complaint', name: '投诉处理专员', description: '客户投诉处理' },
      { id: 'vip-service', name: 'VIP客户经理', description: '高端客户服务' },
      { id: 'after-sales', name: '售后服务专员', description: '售后支持服务' },
      { id: 'service-supervisor', name: '客服主管', description: '客服团队管理' },
      { id: 'service-director', name: '客服经理', description: '客服部门管理' },
      { id: 'quality-assurance', name: '服务质量专员', description: '服务质量监控' },
      { id: 'training-specialist', name: '客服培训专员', description: '客服技能培训' },
    ],
  },
];

// 面试级别
export const LEVELS = ['初级', '中级', '高级'] as const;

// 面试类型
export const INTERVIEW_TYPES = ['技术面试', '行为面试', '综合面试'] as const;
